<template>
  <div class="store-banner-box show-flex-box-r">
    <span class="show-flex-box-r">
      <img src="../../../assets/home/banner-02.jpg" alt="德阳经开科创" draggable="false">
    </span>
  </div>
</template>

<script>
export default {
  name: "store_banner_cpn",
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.store-banner-box {
  width: 100%;
  height: 100%;
  & > span {
    width: 100%;
    & > img {
      display: block;
      width: 100%;
      flex-grow: 1;
      object-fit: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mars_box_store/common/store_banner_cpn.vue